import {createReducer, on} from "@ngrx/store";
import {DealSensitivityState, INITIAL_STATE} from "./deal-sensitivity.state";
import {DealSensitivityActions, DealSensitivityDetailsActions} from "./deal-sensitivity.actions";

export const dealSensitivityStoreFeatureKey = "valumize/deal-sensitivity";

export const dealSensitivityReducer = createReducer(
    INITIAL_STATE,
    on(
        DealSensitivityActions.clearState,
        (): DealSensitivityState => (INITIAL_STATE)),
    on(
        DealSensitivityActions.load,
        DealSensitivityActions.compute,
        (state): DealSensitivityState => ({
            ...state,
            dealSensitivityOverview: {
                ...state.dealSensitivityOverview,
                status: "LOADING",
                errorMessage: ""
            }
        })),
    on(
        DealSensitivityActions.loadSuccess,
        DealSensitivityActions.computeSuccess,
        (state, action): DealSensitivityState => ({
            ...state,
            dealSensitivityOverview: {
                data: action.dealSensitivityOverview,
                status: "LOADED",
                errorMessage: ""
            }
        })),
    on(
        DealSensitivityActions.loadError,
        DealSensitivityActions.computeError,
        (state, {errorMsg}): DealSensitivityState => ({
            ...state,
            dealSensitivityOverview: {
                ...state.dealSensitivityOverview,
                status: "ERROR",
                errorMessage: errorMsg
            }
        })),
    on(
        DealSensitivityDetailsActions.load,
        (state): DealSensitivityState => ({
            ...state,
            dealSensitivity: {
                ...state.dealSensitivity,
                status: "LOADING",
                errorMessage: ""
            }
        })),
    on(
        DealSensitivityDetailsActions.loadSuccess,
        (state, action): DealSensitivityState => ({
            ...state,
            dealSensitivity: {
                data: action.dealSensitivity,
                status: "LOADED",
                errorMessage: ""
            }
        })),
    on(
        DealSensitivityDetailsActions.loadError,
        (state, {errorMsg}): DealSensitivityState => ({
            ...state,
            dealSensitivity: {
                ...state.dealSensitivity,
                status: "ERROR",
                errorMessage: errorMsg
            }
        })),
    on(
        DealSensitivityActions.setColumnTokens,
        (state, {tokens}): DealSensitivityState => ({...state, selectedColumnTokens: tokens})
    )
);
